import React from 'react'
import './index.less'
function Panel(props) {
  const {dataSource = {}, column = [], title = '', style} = props
  return (
    <div className="panel" style={style}>
      {title && <div className="title">{title} </div>}

      <div>
        {column.map((item, index) => {
          const label = item.title
          const key = item.key
          const value = dataSource[`${key}`] || '-'
          const width = item.width || 60
          const {visible = true} = item
          console.log(visible, label)

          return visible ? (
            <div key={key} className="panel_row">
              <div style={{width}} className="panel_row_label">
                {label}
              </div>
              <div className="panel_row_value">
                {item.render ? item.render(value, dataSource, index) : value}
              </div>
            </div>
          ) : (
            ''
          )
        })}
      </div>
    </div>
  )
}

export default Panel
